module.exports = __webpack_public_path__ + "static/landucci-d4ef44357fdb441ac5f17ad6d6309911.jpg";